import { render } from "./card-tab-detail.vue?vue&type=template&id=b4c19ddc&scoped=true&ts=true"
import script from "./card-tab-detail.vue?vue&type=script&lang=ts"
export * from "./card-tab-detail.vue?vue&type=script&lang=ts"

import "./card-tab-detail.vue?vue&type=style&index=0&id=b4c19ddc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4c19ddc"]])

export default __exports__